import { Box } from '@mantine/core';
import { CreateContractForm } from 'components/CreateContractForm';
import { Layout } from 'features/Layouts/Layouts';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export const ContractsCreate = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <Helmet>
        <title>Создать договор</title>
      </Helmet>
      <Box hiddenFrom='sm'>
        <CreateContractForm onComplete={() => navigate('/contracts')} mobile />
      </Box>
    </Layout>
  );
};
